import React from "react";
import "../assets/css/Header.css";
import "../assets/css/MobileMenu.css";
import { useContext, useEffect } from "react";
import Contexto from "../context/Contexto";
import { useNavigate } from "react-router-dom";
import { useState } from "react";
import ImgEntrar from "./ImgEntrar";
import Logo from "../assets/statics/ds-logo.png";
import cerrar from "../assets/CCstatics/cerrar.svg";
import { Link } from "react-router-dom";

function MobileMenu(props) {
  const {
    cliente,
    desconectarUsuario,
    Griseado,
    canjearCursos,
    usuario,
    loguearUsuario,
  } = useContext(Contexto);
  const navigate = useNavigate();

  const { estado, accion } = props;
  useEffect(() => {}, [cliente]);

  const redireccionar = (url) => {
    accion();
    if (url === "desloguear") {
      desconectarUsuario();
      Griseado("/");
    } else {
      Griseado(url);
    }
  };
  const [codiguito, setCodiguito] = useState("");
  const handleCodigo = (e) => {
    setCodiguito(e.target.value);
  };
  const dameRegalo = () => {
    console.log("dameRegalo()", codiguito);
    canjearCursos({ codigo: codiguito, pibe: usuario.uid });
  };
  return (
    <div className={estado} id="menuMobile">
      <header className="header">
        <p>.</p>

        <Link
          to="https://www.colorclub.online/design-season"
          className="logoLink"
        >
          <img src={Logo} alt="" className="CCL" />
        </Link>
        <img src={cerrar} className="burguer" alt="" onClick={accion} />
      </header>

      {cliente && (
        <>
          <div className="infoCliente">
            <ul>
              {/* <h1 className="">{cliente.username}</h1> */}
              {cliente && cliente.designseason24 && !cliente.designseason7 ? (
                <li
                  className="bbt rosalaga"
                  onClick={() => redireccionar("/ver/designseason24")}
                >
                  DesignSeason
                </li>
              ) : cliente.designseason7 ? (
                <li
                  className="bbt rosalaga"
                  onClick={() => redireccionar("/ver/designseason7")}
                >
                  DesignSeason
                </li>
              ) : cliente.designseason8 ? (
                <li
                  className="bbt rosalaga"
                  onClick={() => redireccionar("/ver/designseason8")}
                >
                  DesignSeason
                </li>
              ) : (
                <li
                  className="bbt rosalaga"
                  onClick={() => redireccionar("/ver/designseason10")}
                >
                  DesignSeason
                </li>
              )}

              <li
                onClick={() => redireccionar("/miscursos")}
                className="bbt verdolaga"
              >
                Mis programas{" "}
              </li>
              <li
                onClick={() => redireccionar("/miperfil")}
                className="bbt rosalaga"
              >
                Mi Perfil
              </li>
            </ul>
          </div>
        </>
      )}
      <ul>
        <li className="bbt verdolaga">
          <Link to="https://discord.gg/ZkKKkVaHDK" className="blaco">
            Discord
          </Link>
        </li>
        <li
          onClick={() => {
            redireccionar("desloguear");
          }}
          className="bbt rosalaga"
        >
          CERRAR SESIÓN
        </li>

        {
          //cliente && (
          // <div className="regalines">
          //   <h3 className="txtLetrita white"> Tenés un código de regalo?</h3>
          //   <input
          //     type="text"
          //     onChange={handleCodigo}
          //     className="regalin"
          //     placeholder="Ingresá tu código"
          //   />
          //   <br /> <br />
          //   <button onClick={dameRegalo} className="infoClientebtn">
          //     Dame mi regalo
          //   </button>
          //   <br />
          // </div>
          // )
        }
      </ul>

      <ul>
        <li>
          {!cliente && (
            <ImgEntrar
              accion={loguearUsuario}
              className="header-menuHamburguesa"
              fill="white"
              Hover="#01ff00"
              width="50px"
              height="30px"
            ></ImgEntrar>
          )}
        </li>
      </ul>
    </div>
  );
}

export default MobileMenu;
